<script lang="ts">
	let {
		class: className = '',
		label = 'Iliad'
	}: {
		class?: string;
		label?: string;
	} = $props();
</script>

<span
	class={`inline-block ${className}`}
	role={label ? 'img' : undefined}
	aria-label={label || undefined}
	aria-hidden={label ? undefined : true}
>
	<img
		class="block h-full w-full object-contain dark:hidden"
		src="/brand/iliad-logo-light.svg"
		alt=""
		draggable="false"
	/>
	<img
		class="hidden h-full w-full object-contain dark:block"
		src="/brand/iliad-logo-dark.svg"
		alt=""
		draggable="false"
	/>
</span>
